import { ISocialIcon } from './ISocialIcon';
import React from 'react';

const GoogleSvg = ({
  width = '16',
  height = '16',
  viewBox = '0 0 16 16',
  fill = 'none',
}: ISocialIcon): React.ReactElement => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.54595 9.66894L2.98901 11.7481L0.953408 11.7911C0.345063 10.6628 0 9.37181 0 7.99993C0 6.67334 0.322626 5.42233 0.894502 4.3208H0.894939L2.70719 4.65305L3.50107 6.45443C3.33491 6.93884 3.24435 7.45884 3.24435 7.99993C3.24441 8.58718 3.35079 9.14984 3.54595 9.66894Z"
        fill="white"
      />
      <path
        d="M15.8603 6.50513C15.9521 6.98907 16 7.48885 16 7.99963C16 8.57238 15.9398 9.13107 15.8251 9.66998C15.4357 11.5038 14.4181 13.1051 13.0084 14.2383L13.008 14.2379L10.7253 14.1214L10.4023 12.1047C11.3377 11.5561 12.0687 10.6977 12.4537 9.66998H8.1759V6.50513H12.5161H15.8603Z"
        fill="white"
      />
      <path
        d="M13.008 14.2384L13.0085 14.2389C11.6375 15.3408 9.89592 16.0002 8.0001 16.0002C4.9535 16.0002 2.30471 14.2973 0.953491 11.7914L3.54603 9.66919C4.22162 11.4723 5.96097 12.7558 8.0001 12.7558C8.87657 12.7558 9.6977 12.5189 10.4023 12.1052L13.008 14.2384Z"
        fill="white"
      />
      <path
        d="M13.1064 1.84175L10.5148 3.96351C9.78555 3.50769 8.92355 3.24438 8.00005 3.24438C5.91476 3.24438 4.14288 4.58679 3.50113 6.45451L0.894969 4.32088H0.894531C2.22597 1.75385 4.90817 0 8.00005 0C9.94115 0 11.7209 0.691439 13.1064 1.84175Z"
        fill="white"
      />
    </svg>
  );
};

export default GoogleSvg;
